var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsArray, IsOptional, IsUUID, ValidateIf } from 'class-validator';
/**
 * One patient's Verordnung on an appointment (#1896): a plan and its units links or
 * swaps, no plan unlinks. That patient's units on the appointment are released first.
 */
export class SetAppointmentPlanLinkDto {
    patientId;
    treatmentPlanId;
    billableServiceItemIds;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], SetAppointmentPlanLinkDto.prototype, "patientId", void 0);
__decorate([
    ValidateIf((dto) => dto.treatmentPlanId !== null),
    IsUUID(),
    __metadata("design:type", Object)
], SetAppointmentPlanLinkDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], SetAppointmentPlanLinkDto.prototype, "billableServiceItemIds", void 0);
//# sourceMappingURL=set-appointment-plan-link.dto.js.map